export default __webpack_public_path__ + "static/media/alertsLight.fa9fdb3f.svg";